$('#usageSectionList').slick({
    mobileFirst: true,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 520,
            settings: "unslick"
        }
    ]
});